import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import { Icon } from "components";

const Pagination = (props) => {
  const {
    count,
    onChangePage,
    onChangeRowsPerPage,
    page,
    rowsPerPage,
    rowsPerPageOptions,
  } = props;

  const [initialRange, setInitialRange] = useState(0);
  const [finalRange, setFinalRange] = useState(0);

  useEffect(() => {
    const base = (page + 1) * rowsPerPage;

    setInitialRange(page === 0 ? 1 : base - (rowsPerPage - 1));
    setFinalRange(base > count ? count : base);
  }, [count, page, rowsPerPage]);

  return (
    <div className="d-flex align-items-center justify-content-end mb-1">
      <small className="mr-1">Registros por página:</small>
      <Form.Group controlId="exampleForm.ControlSelect1" className="p-0 m-0">
        <Form.Control
          as="select"
          size="sm"
          defaultValue={rowsPerPage}
          onChange={onChangeRowsPerPage}
        >
          {rowsPerPageOptions.map((item, index) => (
            <option key={index}>{item}</option>
          ))}
        </Form.Control>
      </Form.Group>
      <small className="mx-4">
        {initialRange} - {finalRange} de {count}
      </small>

      <div className="d-flex justify-content-between" style={{ width: 60 }}>
        {page > 0 ? (
          <Icon
            name="keyboard_arrow_left"
            style={{ cursor: "pointer" }}
            onClick={() => onChangePage(page - 1)}
          />
        ) : (
          <Icon name="keyboard_arrow_left" style={{ color: "#858585" }} />
        )}

        {page + 1 !== Math.ceil(count / rowsPerPage) ? (
          <Icon
            name="keyboard_arrow_right"
            style={{ cursor: "pointer" }}
            onClick={() => onChangePage(page + 1)}
          />
        ) : (
          <Icon name="keyboard_arrow_right" style={{ color: "#858585" }} />
        )}
      </div>
    </div>
  );
};

Pagination.propTypes = {
  onChangePage: PropTypes.func,
  onChangeRowsPerPage: PropTypes.func,
  count: PropTypes.number,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  rowsPerPageOptions: PropTypes.array,
};

Pagination.defaultProps = {
  onChangePage: () => {},
  onChangeRowsPerPage: () => {},
  count: 0,
  page: 0,
  rowsPerPage: 0,
  rowsPerPageOptions: [],
};

export default Pagination;
